import React from "react";
import Carousel from "react-slick";
import styles from "./CarouselVar.module.scss";

function CarouselVar({ images }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Carousel {...settings}>
      {images.map((image, index) => (
        <div key={index} className={styles.imageContainer}>
          <img src={image.src} alt={image.alt} className={styles.carouselImage} />
          <div className={styles.slickCaption}>
            <h4>{image.location}</h4>

          </div>
        </div>
      ))}
    </Carousel>
  );
}

export default CarouselVar;